const FolderHierarchyItemType = [
	{
		Type: "FolderHierarchyItemType_Field",
		Label: "Index Field",
	},
];

export default FolderHierarchyItemType;